import React from 'react';
import MetricLinksDialog from '../../../../shared/components/MetricLinksDialog';
import { DOCUMENT_OVERVIEW_LABELS, getDocumentDueDate } from '../../utils/documents.overview';
import { formatDocumentDate } from '../../utils';
import { getDocumentStatusView } from './documentsPage.config';

export default function DocumentsMetricDialog({ metric, documents, onClose, onSelect }) {
  return (
    <MetricLinksDialog
      isOpen={Boolean(metric)}
      onClose={onClose}
      title={DOCUMENT_OVERVIEW_LABELS[metric] || 'Documenti'}
      iconKey="nav.documents"
      itemIconKey="metrics.document"
      subtitle={`${documents.length} ${documents.length === 1 ? 'documento' : 'documenti'}`}
      className="documents-metric-dialog"
      items={documents}
      getItemLabel={(document) => document.name || document.fileName || 'Documento'}
      getItemDescription={(document) => getDocumentStatusView(document.status).label}
      getItemDetail={(document) => getDocumentDueDate(document) ? `Scadenza: ${formatDocumentDate(getDocumentDueDate(document))}` : ''}
      itemActionLabel="Apri documento"
      onSelect={onSelect}
      emptyMessage={`Nessun documento ${metric === 'overdue' ? 'scaduto' : 'da completare'}.`}
    />
  );
}
